/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@covalent/core/steps/step.component';
const styles_TdStepComponent:any[] = ([] as any[]);
export const RenderType_TdStepComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_TdStepComponent,data:{}});
function View_TdStepComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n  '])),i0.ɵncd((null as any),
      0),(_l()(),i0.ɵted((null as any),['\n']))],(null as any),(null as any));
}
export function View_TdStepComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{_content:0}),(_l()(),i0.ɵand(0,[[1,2]],(null as any),
      0,(null as any),View_TdStepComponent_1))],(null as any),(null as any));
}
export function View_TdStepComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(16777216,(null as any),(null as any),4,'td-step',
      ([] as any[]),(null as any),(null as any),(null as any),View_TdStepComponent_0,
      RenderType_TdStepComponent)),i0.ɵdid(114688,(null as any),3,i1.TdStepComponent,
      [i0.ViewContainerRef],(null as any),(null as any)),i0.ɵqud(335544320,1,{stepLabel:0}),
      i0.ɵqud(335544320,2,{stepActions:0}),i0.ɵqud(335544320,3,{stepSummary:0})],(_ck,
      _v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TdStepComponentNgFactory:i0.ComponentFactory<i1.TdStepComponent> = i0.ɵccf('td-step',
    i1.TdStepComponent,View_TdStepComponent_Host_0,{label:'label',sublabel:'sublabel',
        disableRipple:'disableRipple',active:'active',disabled:'disabled',state:'state'},
    {onActivated:'activated',onDeactivated:'deactivated'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9ub2RlX21vZHVsZXMvQGNvdmFsZW50L2NvcmUvc3RlcHMvc3RlcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9ub2RlX21vZHVsZXMvQGNvdmFsZW50L2NvcmUvc3RlcHMvc3RlcC5jb21wb25lbnQuZC50cyIsIm5nOi8vL0M6L1VzZXJzL29yaW9uL1Byb2plY3RzL3NpbXBsaWNpdHlFbmdpbmUvdmFsbXVzdC92YWxtdXN0ZmUvbm9kZV9tb2R1bGVzL0Bjb3ZhbGVudC9jb3JlL3N0ZXBzL3N0ZXAuY29tcG9uZW50Lmh0bWwiLCJuZzovLy9DOi9Vc2Vycy9vcmlvbi9Qcm9qZWN0cy9zaW1wbGljaXR5RW5naW5lL3ZhbG11c3QvdmFsbXVzdGZlL25vZGVfbW9kdWxlcy9AY292YWxlbnQvY29yZS9zdGVwcy9zdGVwLmNvbXBvbmVudC5kLnRzLlRkU3RlcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxuZy10ZW1wbGF0ZT5cbiAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuPC9uZy10ZW1wbGF0ZT4iLCI8dGQtc3RlcD48L3RkLXN0ZXA+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7b0JDQWEsZ0RBQ1g7TUFBQSxHQUF5Qjs7O3NEQUQzQjtNQUFBOzs7b0JDQUE7TUFBQTtnQ0FBQSxVQUFBO01BQUE7YUFBQTs7SUFBQTs7Ozs7OyJ9



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/core/steps/step.component.ngfactory.ts